module.exports = __webpack_public_path__ + "static/media/carrsqc.0e353a2a.svg";